//排放标准
export const emissionStandardList = [
  {
    label: "国一",
    value: '01',
  },
  {
    label: "国二",
    value: '02',
  },
  {
    label: "国三",
    value: '03',
  },
  {
    label: "国四",
    value: '04',
  },
  {
    label: "国五",
    value: '05',
  },
  {
    label: "国六",
    value: '06',
  },
  {
    label: "氢能",
    value: '10',
  },
  {
    label: "电动",
    value: '11',
  },
]

//车辆类型
export const vehicleTypeList = [
  {
    label: "其他",
    value: 'car_00',
  },
  {
    label: "客车",
    value: 'car_01',
  },
  {
    label: "货车",
    value: 'car_02',
  },
  {
    label: "货用皮卡",
    value: 'car_03',
  },
  {
    label: "客用皮卡",
    value: 'car_04',
  },
  {
    label: "汽车吊",
    value: 'car_05',
  },
  {
    label: "搅拌车",
    value: 'car_06',
  },
  {
    label: "危险品车辆",
    value: 'car_07',
  },
]

//运输类型 
export const transportTypeList = [
  {
    label: "普货车辆",
    value: '0',
  },
  {
    label: "危险品车辆",
    value: '1',
  },
]
//燃油类型 
export const fuelTypeList = [
  {
    label: "燃油",
    value: '0',
  },
  {
    label: "新能源",
    value: '1',
  },
]
//车牌颜色 
export const licensePlateColourList = [
  {
    label: "白色",
    value: '0',
  },
  {
    label: "黄色",
    value: '1',
  },
  {
    label: "蓝色",
    value: '2',
  },
  {
    label: "黑色",
    value: '3',
  },
  {
    label: "黄绿色",
    value: '5',
  },
  {
    label: "绿色",
    value: '6',
  },
  {
    label: "其他",
    value: '7',
  },
]
/**
 * 传入对象与key值，返回当前名字
 * @param {*} obj array 类型数组
 * @param {*} key key 需要变化的key值
 */
export const changeKeyToName = (obj, key) => {
  let name = key
  if(obj){
    obj.map(item => {
      if (item.value == key) {
          name = item.label
      }
    })
  }
  return name
}